import axios from 'axios'

const local = {
    OrdemServicoApi: 'https://localhost:44394/api/v1',
    SingleTreesApi: 'https://localhost:44353/api/v1',
    RegistryApi: 'https://localhost:44322/api/v1',
    WalterApi: 'https://localhost:44365/api/v1',
    WalterBIApi: 'https://localhost:44321/api/v1',
    AuthApi: 'https://auth.smartforest.com.br',
    Engineering: 'http://localhost:5102/api/v1',
    // Operações SingleTrees rodam na Engineering do lab (Fedora + túnel Cloudflare),
    // não na Engineering de produção — ver SingleTreesOpsRequests.js
    SingleTreesOps: 'http://localhost:5102/api/v1'
}

const testing = {
    OrdemServicoApi: 'https://testing-ordemservico.smartforest.com.br/api/v1',
    SingleTreesApi: 'https://testing-singletrees.smartforest.com.br/api/v1',
    RegistryApi: 'https://testing-web-registry.smartforest.com.br/api/v1',
    WalterApi: 'https://testing-walter.smartforest.com.br/api/v1',
    WalterBIApi: 'https://testing-web-walterbi.smartforest.com.br/api/v1',
    AuthApi: 'https://testing-web-auth.smartforest.com.br',
    Engineering: 'https://testing-engenharia.smartforest.com.br/api/v1',
    SingleTreesOps: 'https://engenharia-lab.treevia.com.br/api/v1'
}

const production = {
    OrdemServicoApi: 'https://ordemservico.smartforest.com.br/api/v1',
    SingleTreesApi: 'https://singletrees.smartforest.com.br/api/v1',
    RegistryApi: 'https://web-registry.smartforest.com.br/api/v1',
    WalterApi: 'https://walter.smartforest.com.br/api/v1',
    WalterBIApi: 'https://web-walterbi.smartforest.com.br/api/v1',
    AuthApi: 'https://web-auth.smartforest.com.br/api/v1',
    // TEMPORÁRIO: Engineering aponta para o lab (Fedora + túnel Cloudflare) até a
    // release do back com o cadastro de clientes chegar na VM de produção —
    // voltar para https://engenharia.smartforest.com.br/api/v1 ao fechar a release
    Engineering: 'https://engenharia-lab.treevia.com.br/api/v1',
    SingleTreesOps: 'https://engenharia-lab.treevia.com.br/api/v1'
}

const baseUrl = (apiName) => {
    const { hostname } = window.location

    // Em dev (npm run serve) usa as APIs locais; qualquer outro host usa produção
    if (hostname.includes('localhost')) {
        return local[apiName];
    }
    return production[apiName]
}

// O JwtBearer das APIs exige o scheme no header ("Bearer <token>") — token cru é
// ignorado e responde 401 (o IIS antigo não validava auth, por isso nunca doeu lá).
const montarAuthorization = () => {
    const jwt = localStorage.getItem('jwt')
    return jwt ? `Bearer ${jwt}` : undefined
}

const headers = { Authorization: montarAuthorization() }

const authApi = axios.create({
    baseURL: baseUrl('AuthApi')
})

const ordemServicoApi = axios.create({
    baseURL: baseUrl('OrdemServicoApi'), headers
})

const registryApi = axios.create({
    baseURL: baseUrl('RegistryApi'), headers
})

const singleTreesApi = axios.create({
    baseURL: baseUrl('SingleTreesApi'), headers
})

const walterApi = axios.create({
    baseURL: baseUrl('WalterApi'), headers
})

const walterBIApi = axios.create({
    baseURL: baseUrl('WalterBIApi'), headers
})

const EngineeringApi = axios.create({
    baseURL: baseUrl('Engineering'), headers

})

const SingleTreesOpsApi = axios.create({
    baseURL: baseUrl('SingleTreesOps'), headers
})

/**
 * Metodo para setar os authorization apos realizar login de usuario, o metodo e necessario
 * pois a variavel headers criada anteriormente nao e atualizada automaticamente com o jwt vindo do localstorage
 * sendo necessario atualizar atraves da chamada deste metodo
 */
const setAuthorizationAfterLogin = () => {
    ordemServicoApi.defaults.headers.Authorization = montarAuthorization();
    registryApi.defaults.headers.Authorization = montarAuthorization();
    singleTreesApi.defaults.headers.Authorization = montarAuthorization();
    walterApi.defaults.headers.Authorization = montarAuthorization();
    walterBIApi.defaults.headers.Authorization = montarAuthorization();
    EngineeringApi.defaults.headers.Authorization = montarAuthorization();
    SingleTreesOpsApi.defaults.headers.Authorization = montarAuthorization();

}

export { authApi, ordemServicoApi, registryApi, singleTreesApi, walterApi, walterBIApi, EngineeringApi, SingleTreesOpsApi, setAuthorizationAfterLogin }

